import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { PropsWithChildren } from 'react';

export const Card: React.FC<PropsWithChildren<{ testId: string }>> = ({ children, testId }) => (
  <FuelFlex
    defaultProps={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'km4',
      padding: 'km4',
      width: '300px',
      maxWidth: '300px',
      borderRadius: 'small',
      borderColor: DS_TOKENS.color.border.neutral.default,
      borderStyle: 'solid',
      borderWidth: 'thinner',
      backgroundColor: DS_TOKENS.color.background.neutral.default,
    }}
    testId={testId}
  >
    {children}
  </FuelFlex>
);
